// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","summary":"styles_summary__Yhoto","row":"styles_row__evflW","invoiceTitle":"styles_invoiceTitle__1qjOh"};